import {
  fetchWrapper,
  handleResponse,
  hcUrl,
  buildOpts,
  transformMealResponse,
} from 'services/RequestService/helpers';

export const getPauseDeflectorMeals = async () => {
  const response = await fetchWrapper(hcUrl('/liked_meals'), buildOpts());

  return handleResponse(response);
};

export const getMeal = async ({ params: { mealId } }) => {
  const response = await fetchWrapper(hcUrl(`/meals/${mealId}`), buildOpts());

  return handleResponse(response, transformMealResponse);
};
